import sessionReader from '../store/readHelpers/SessionReader';
import liveDataLoader from '../loading/liveDataLoader';
import apiService from './api/ApiService';
import navigationService from './NavigationService';

/**
 * Service for starting standalone tests
 */
const standaloneTestStarter = {
    /**
     * Starts a standalone test and returns a promise
     *
     * @param {Object} test - The test object containing assessmentRunId
     * @returns {Promise} - A promise that resolves when the test has been started
     */
    startStandaloneTest(test) {
        let startTestPromise = null;

        if (sessionReader.isTestThatRequiresPreStartStepAndSittingHasNotYetStarted()) {
            startTestPromise = liveDataLoader.loadInitialData(
                true // isSittingStartInitiatedAfterPrechecks
            );
        } else {
            startTestPromise = apiService.startCountdown(test.assessmentRunId)
                .then(() => {
                    navigationService.navigateToFirstQuestion();
                });
        }

        return startTestPromise;
    },
};

export default standaloneTestStarter;
